import type { InitialParams } from '@/app/components/hotel-detail/InitialParamsProvider';

export const HOTEL_ROOM_OPTION_CLICKED = 'HOTEL_ROOM_OPTION_CLICKED';
export const HOTEL_ROOM_OPTION_CLICKED_VERSION = '1.0';

export type HotelRoomOptionClickedPayload = {
  desiredProfitPricingId: string;
  internalHotelId: number;
  mealPlanClass: string;
  optionIndex: number;
  productDetailKey: string;
  providerId: string;
  roomId: string;
  searchId: string;
};

export type HotelRoomOptionClickedParams = {
  searchId: string;
  initialParams: Pick<InitialParams, 'internalHotelId' | 'productDetailKey'>;
  room: Pick<RoomType, 'roomId'>;
  mealPlan: Pick<MealPlanType, 'boardClass' | 'index' | 'dynamicPricingId' | 'supplier'>;
};

export const createHotelRoomOptionClickedPayload = ({
  searchId,
  initialParams: { internalHotelId, productDetailKey },
  room: { roomId },
  mealPlan,
}: HotelRoomOptionClickedParams): HotelRoomOptionClickedPayload => ({
  searchId,
  internalHotelId,
  roomId,
  providerId: mealPlan.supplier?.id?.toString(),
  productDetailKey,
  mealPlanClass: mealPlan.boardClass,
  optionIndex: mealPlan.index,
  desiredProfitPricingId: mealPlan.dynamicPricingId,
});
